/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_InvoiceInputs */

const en_settings_payments_invoice = /** @type {(inputs: Settings_Payments_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

const zh_settings_payments_invoice = /** @type {(inputs: Settings_Payments_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发票`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Settings_Payments_InvoiceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_invoice = /** @type {((inputs?: Settings_Payments_InvoiceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_InvoiceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_invoice(inputs)
	return zh_settings_payments_invoice(inputs)
});
export { settings_payments_invoice as "settings.payments.invoice" }